import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('LoaderIconContainer')(
  css({
    position: 'absolute',
    zIndex: '2',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    minHeight: ['200px', '180px', '400px'],
  }),
);

themeStyles.addBaseStyles('StyledWrapper')(
  css({
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    pr: ['zero', 'zero', 's'],
    mb: ['xs', 'xs', 'zero'],
    mt: ['zero', 's', 'zero'],
  }),
);

themeStyles.addBaseStyles('TrimOverviewContainer')(
  css({
    px: ['zero', '28px', '28px'],
    border: '1px solid transparent',
    pt: ['zero', 'zero', 'l'],
  }),
);

themeStyles.addBaseStyles('StyledTitle')(({ justifyContent }) =>
  css({
    fontFamily: 'bold',
    cursor: 'auto',
    gridColumn: 1,
    gridRow: 2,
    display: 'flex',
    justifyContent,
  }),
);

themeStyles.addBaseStyles('StyledTrimCarousel')(
  css({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'zero',
    pb: ['32px', '32px', 'zero'],
    width: '100%',
  }),
);

themeStyles.addBaseStyles('TrimCarouselVehicleImage')(({ isPlaceholder, backgroundImageSrc }) =>
  css({
    background: `url(${backgroundImageSrc})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: isPlaceholder ? '30%' : 1,
    willChange: 'transform',
  }),
);

themeStyles.addBaseStyles('TrimCarouselAccessoryOverlayImage')(
  css({
    position: 'absolute',
    top: 0,
    left: 0,
  }),
);

themeStyles.addBaseStyles('TrimCarouselToastContainer')(
  css({
    position: 'absolute',
    bottom: ['80px', '80px', '30px'],
    left: '50%',
    right: [0, null, null],
    transform: 'translateX(-50%)',
    width: 'max-content',
  }),
);

themeStyles.addBaseStyles('TrimCarouselToast')(
  css({
    display: 'flex',
    backgroundColor: '#000000',
    color: 'white',
    padding: 's',
    marginX: '10vw',
    gap: 'xs',
    alignItems: 'center',
    borderRadius: '3px',
  }),
);

themeStyles.addBaseStyles('TrimCarouselToastIcon')(
  css({
    flexShrink: 0,
    alignSelf: ['flex-start', 'center', 'center'],
  }),
);

themeStyles.addBaseStyles('StyledTrim360')(
  css({
    display: 'flex',
    flexDirection: ['column-reverse', 'column-reverse', 'column'],
    position: 'relative',
    mb: ['32px', '32px', 'zero'],
    width: '100%',
  }),
);

themeStyles.addBaseStyles('TrimToggleContent')(({ hasMarginTop }) =>
  css({
    display: 'flex',
    position: 'relative',
    bottom: ['zero', 'zero', '14px'],
    right: ['auto', 0],
    width: ['100%', 'auto'],
    top: ['zero', 'zero', 'auto'],
    justifyContent: ['center', 'center', 'flex-end'],
    mt: hasMarginTop && ['zero', 'zero', 'default'],
    order: ['-1', '-1', '1'],
  }),
);

themeStyles.addBaseStyles('StyledTrimDetails')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: ['xs', 'xs', 'm'],
    fontWeight: 'bold',
    width: '50%',
    pl: ['20px', '20px', 'default'],
  }),
);

themeStyles.addBaseStyles('TrimInfoWrapper')(
  css({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    pl: ['20px', 's', 's'],
    pr: ['20px', 'zero', 'zero'],
    mt: ['24px', '24px', 'zero'],
    pb: ['xs', 'xs', 'm'],
  }),
);

themeStyles.addBaseStyles('TrimInfoBadgeWrapper')(({ hasPriceError }) =>
  css({
    gridColumn: '1',
    gridRow: '1',
    mt: 'xs',
    mb: [hasPriceError ? 'xs' : 'm', 'm', 'l'],
  }),
);
themeStyles.addBaseStyles('PriceWrapper')(
  css({
    gridColumn: '2',
    gridRow: '1',
  }),
);

themeStyles.addBaseStyles('ModelBadge')(
  css({
    height: ['15px', '15px', '25px'],
    width: ['135px', '135px', '210px'],
    objectFit: 'contain',
  }),
);

themeStyles.addBaseStyles('StyledBasePaginator')(
  css({
    zIndex: '2',
    width: ['100%', '100%', '50% !important'],
    mx: 'auto',
    mt: ['20px', 'zero', '-21px'],
  }),
);

export default themeStyles;
